const SvgSoftware1 = (props) => (
  <>
    <path
      d="M36 0h24v24H36zM72 72h24v24H72zM36 72h24v24H36zM72 36h24v24H72zM0 36h24v24H0zM0 0h24v24H0zM36 36h24v24H36zM0 72h24v24H0zM72 0h24v24H72z"
      fill={props.p40}
    />
  </>
);

export default SvgSoftware1;
